export function serverMigrationServerValidationErrors(validationErrors) {
  return function (dispatch) {
    dispatch({
      type: "SERVER-MIGRATION-SERVER-VALIDATION-ERRORS",
      validationErrors,
    });
  };
}

export function onServerMigrationSubmit() {
  return function (dispatch) {
    dispatch({ type: "ON-SERVER-MIGRATION-SUBMIT" });
  };
}

export function onServerMigrationChange(name, value) {
  return function (dispatch) {
    dispatch({ type: "ON-SERVER-MIGRATION-CHANGE", name, value });
  };
}

export function onServerMigrationModeChange(mode) {
  return function (dispatch) {
    dispatch({ type: "ON-SERVER-MIGRATION-MODE-CHANGE", mode });
  };
}

export function cancelServerMigrationDispatch() {
  return function (dispatch) {
    dispatch({ type: "CANCEL-SERVER-MIGRATION-DISPATCH" });
  };
}

export function setDefaultServerMigration() {
  return function (dispatch, getState) {
    let { getSite } = getState();
    let path = getSite && getSite.success && getSite.success.path;
    dispatch({ type: "SET-DEFAULT-SERVER-MIGRATION-", path });
  };
}

export function setSitesId(site_id) {
  return function (dispatch) {
    dispatch({ type: "SET-SITE-ID", site_id });
  };
}

export function serverMigrationError(error) {
  return function (dispatch) {
    dispatch({ type: "SET-SERVER-MIGRATION-ERROR", error });
  };
}
